import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { fadeInOutAnimation } from '@newroom-connect/library/animations';
import { ActionRole } from '@newroom-connect/library/enums';
import { ICountry } from '@newroom-connect/library/interfaces';
import { CountryService } from '@newroom-connect/library/services';

import { ButtonComponent } from '../../../buttons/button/button.component';
import { InputRadioComponent } from '../../../inputs/input-radio/input-radio.component';
import { InputSelectComponent } from '../../../inputs/input-select/input-select.component';
import { InputTextComponent } from '../../../inputs/input-text/input-text.component';

@Component({
  standalone: true,
  imports: [
    ReactiveFormsModule,
    ButtonComponent,
    InputRadioComponent,
    InputSelectComponent,
    InputTextComponent
  ],
  selector: 'nrc-sign-up-form-profile',
  templateUrl: './sign-up-form-profile.component.html',
  animations: [fadeInOutAnimation]
})
export class SignUpFormProfileComponent implements OnInit {
  @Output() public backEvent = new EventEmitter<void>();
  @Output() public doneEvent = new EventEmitter<{
    gender: string,
    firstName: string,
    lastName: string,
    company: string,
    purpose: string,
    country: string,
    pronoun?: string
  }>();

  public actionRole = ActionRole;

  public genders = ['FEMALE', 'MALE', 'DIVERS'].map(gender => ({ value: gender, label: gender }));

  public countries: ICountry[] = [];

  public signUpProfileForm = new FormGroup({
    gender: new FormControl('', [Validators.required]),
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    company: new FormControl('', [Validators.required]),
    purpose: new FormControl(null, [Validators.required]),
    country: new FormControl('', [Validators.required]),
    pronoun: new FormControl(null)
  });

  private countries$: Observable<{ data: ICountry[]; }>;

  /**
   * @constructor
   *
   * @param countryService
   */
  constructor(
    private readonly countryService: CountryService
  ) {
    this.countries$ = this.countryService.listCountries().pipe(takeUntilDestroyed());
  }

  /**
   *
   */
  public ngOnInit(): void {
    this.countries$.subscribe(countries => {
      this.countries = countries.data;
    });
  }

  /**
   *
   */
  public back(): void {
    this.backEvent.emit();
  }

  /**
   *
   */
  @HostListener('document:keyup.enter')
  public done(): void {
    this.doneEvent.emit(this.signUpProfileForm.value as any);
  }
}
